import React from 'react'
import TeacherPerson from './TeahcerPerson'
import TeacherProperty from './TeacherProperty'

function TeacherRightSideContent() {
	return (
		<div>
			<TeacherPerson />
			<TeacherProperty />
		</div>
	)
}

export default TeacherRightSideContent
